import React from 'react'
import { Route, Routes } from 'react-router-dom'
import PartnersList from './PartnersList'
import PartnerDetail from './PartnerDetail'
import ApplicationsQueue from './ApplicationsQueue'
import PayoutsQueue from './PayoutsQueue'
import ProgramConfig from './ProgramConfig'

const Partners: React.FC = () => (
  <Routes>
    <Route path="/" element={<PartnersList />} />
    <Route path="/applications" element={<ApplicationsQueue />} />
    <Route path="/payouts" element={<PayoutsQueue />} />
    <Route path="/config" element={<ProgramConfig />} />
    <Route path="/:partnerId" element={<PartnerDetail />} />
  </Routes>
)

export default Partners
